var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 412,
    viewBox: "0 0 486 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M614 307C614 476.551 476.551 614 307 614C137.449 614 0 476.551 0 307C0 137.449 137.449 0 307 0C476.551 0 614 137.449 614 307ZM154.164 307C154.164 391.409 222.591 459.836 307 459.836C391.409 459.836 459.836 391.409 459.836 307C459.836 222.591 391.409 154.164 307 154.164C222.591 154.164 154.164 222.591 154.164 307Z",
    fill: "#197FFF",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse4);
export default __webpack_public_path__ + "static/media/Ellipse4.9e30169a9d6089291a1dd99a8fbd20c2.svg";
export { ForwardRef as ReactComponent };